require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./data-visualization-data-visualization-with-d-3-add-a-hover-effect-to-a-d-3-element.json") })
        }
      }, "path---data-visualization-data-visualization-with-d-3-add-a-hover-effect-to-a-d-3-element");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---data-visualization-data-visualization-with-d-3-add-a-hover-effect-to-a-d-3-element!./.cache/json/data-visualization-data-visualization-with-d-3-add-a-hover-effect-to-a-d-3-element.json
// module id = 1945
// module chunks = 231608221292675